function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartlineup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 3.7a.8.8 0 01.8.8v10.069l4.635-4.635a.8.8 0 011.13 0L12 12.37 17.57 6.8H15.75a.8.8 0 010-1.6h3.75a.797.797 0 01.8.8v3.75a.8.8 0 01-1.6 0V7.931l-6.134 6.135a.8.8 0 01-1.132 0L9 11.63l-5.2 5.2V18.7H21a.8.8 0 010 1.6H3a.8.8 0 01-.8-.8v-15a.8.8 0 01.8-.8z",
    fill: props.fill
  }));
}

export default SvgChartlineup;